<template>
    <v-dialog v-model="dialog" persistent max-width="800">
        <v-card>
            <v-card-title class="primary white--text headline">{{uploadTitle|translate}}</v-card-title>
            <v-card-text>
<v-stepper
          v-model="e6"
          vertical
        >
    <v-stepper-step
      :complete="e6 > 1"
      step="1"
    >
      {{'Upload File'|translate}}

    </v-stepper-step>

    <v-stepper-content step="1">
      <v-card flat>
                <v-card-actions>
            <form>
              <input type="file" name='filename'
                     @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length"/><br/>
            </form>
          </v-card-actions>
          <v-card-text>
              <v-switch color="success"  class="ml-2"
                        v-if="hasRemoveSwitch"
                        v-model="removeExisting"
                        :label="'Remove existing rules'|translate"
              ></v-switch>
              <v-switch color="success"  class="ml-2"
                        v-if="cleanup"
                        v-model="convertCategorical"
                        :label="'Convert categorical to numeric'|translate"
              ></v-switch>
              <v-switch color="success"  class="ml-2"
                        v-if="cleanup"
                        v-model="allowFutureUpload"
                        :label="'Allow upload of future timestamps'|translate"
              ></v-switch>
              <v-select v-if="cleanup" v-model="cleanupOption" :items="cleanupOptions" class="ma-2" :label="'Resampling'|translate"></v-select>
              <v-select v-if="cleanup&&endpoint==='/multiple-series-upload/'" v-model="alternative_col_matching" :items="matchingOptions" class="ma-2" :label="'Matching'|translate"></v-select>
              <v-switch color="success"  class="ml-2"
                        v-if="cleanup&&endpoint==='/multiple-series-upload/'&&alternative_col_matching==='equipmentName - sensorName'"
                        v-model="autocreate_sensors"
                        :label="'Auto-create missing equipments and sensors'|translate"
              ></v-switch>
              <v-text-field v-if="cleanup&&endpoint==='/multiple-series-upload/'&&alternative_col_matching==='equipmentName - sensorName'&&autocreate_sensors"
                            v-model="autocreate_sensor_type"
                            :label="'Default type'|translate">
              </v-text-field>
              <v-text-field v-if="cleanup&&endpoint==='/multiple-series-upload/'&&alternative_col_matching==='equipmentName - sensorName'&&autocreate_sensors"
                            v-model="autocreate_sensor_floor"
                            :label="'Default floor'|translate">
              </v-text-field>

              <v-select
                  v-if="diffOptions"
                  :items="diffModes"
                  label="Diff mode"
                  v-model="diffMode"
              ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-btn class="primary" @click="continueWithFile">{{'Upload'|translate}}</v-btn>
            <v-btn class="primary" @click="dialog=false">{{'Cancel'|translate}}</v-btn>
          </v-card-actions>
        </v-card>
    </v-stepper-content>


    <v-stepper-step
      :complete="e6 > 2"
      step="2"
    >
      {{title|translate}}
    </v-stepper-step>

    <v-stepper-content step="2">
      <v-flex xs12>
        <div class="text-xs-center" v-if="uploading">
                    <v-progress-circular
                      :rotate="360"
                      :size="50"
                      :width="5"
                      indeterminate
                      color="accent darken-1"
                    >
                    </v-progress-circular></div>
        <div>
            <pre>{{currentStatus|translate}}</pre>
        </div>
      </v-flex>
      <v-btn block class="accent" @click="markASDone" v-if="!uploading">{{'Done'|translate}} </v-btn>
    </v-stepper-content>
        </v-stepper>
            </v-card-text>
            <v-card-actions></v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {upload} from '../../upload'

  export default {
    name: 'MaintenanceUploadDialog',
    props: {
      value: {type: Boolean, default: false},
      title: {type: String, default: "Maintenance Records Creation"},
      uploadTitle: {type: String, default: "Upload Excel"},
      endpoint: {type: String, default: "/maintenancerecord/upload/"},
      hasRemoveSwitch: {type: Boolean, default: false},
      cmcmode: {type: Boolean, default: false},
      cleanup: {type: Boolean, default: false},
      sensorId: {type: Number, default: null},
      diffOptions: {type: Boolean, default: false},
    },
      data() {
          return {
              dialog: false,
              removeExisting: false,
              e6: 0,
              name: null,
              percentCompleted: 0,
              currentStatus: null,
              uploading: false,
              cleanupOptions: ["asfreq", "ffill", "bfill", "nearest","convert_monthly_to_custom_month"],
              matchingOptions: ["equipmentName - sensorName","upstream_id", "upstream_sensor_name"],
              alternative_col_matching:"equipmentName - sensorName",
              cleanupOption: "asfreq",
              convertCategorical:false,
              allowFutureUpload:false,
              diffMode: "append only",
              diffModes: ["append only","upstream_id and connector_id","sensor_id"],
              autocreate_sensors: false,
              autocreate_sensor_floor:"imported",
              autocreate_sensor_type:"imported",
          }
    },
    watch: {
      dialog (){
        if (this.value != this.dialog) {
          this.$emit('input', this.dialog)
        }
      },
      value (){
        this.dialog = this.value
      }
    },
    mounted() {
      this.dialog = this.value
    },
    methods: {
        markASDone(){
            this.$emit('doreload')
            this.dialog=false
        },
      filesChange (fieldName, fileList) {
        this.fileList = fileList
        //if (this.name === '') {
          this.name = fileList[0].name
        //}
      },
      onProgress (percentCompleted) {
        this.percentCompleted = percentCompleted
      },
      continueWithFile () {
        if (this.name) {
          this.process()
        } else {
          this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('File must be selected.'), to:null, active: true})
        }
      },
      async process () {
        if (this.fileList.length !== 1) {
          this.$store.dispatch('callSnackbar', {text: this.$options.filters.translate('Exactly 1 file must be provided.'), to:null, active: true})
          this.currentStatus = 'Please select 1 file to upload.'
          return
        }
        this.e6 = 2

        const formData = new FormData()
        const BASE_URL = this.$store.getters.apiBaseURL
        // append the files to FormData
        const url = `${BASE_URL}`+this.endpoint
        Array
          .from(Array(this.fileList.length).keys())
          .map(x => {
            formData.append('file', this.fileList[x], this.fileList[x].name)
          })

        this.currentStatus = 'Please wait ... It will take up to a minute.'
        this.uploading = true
        // create new project
        formData.set('facility_id', this.$store.state.pointsListStore.pointsList.facility_id)
          if(this.cleanup){
              formData.set('cleanup', this.cleanupOption)
              formData.set('convert_categorical', this.convertCategorical)
              formData.set('future_upload_flag', this.allowFutureUpload)
              if (this.endpoint==='/multiple-series-upload/'){
                  formData.set('alternative_col_matching', this.alternative_col_matching)
                  if (this.alternative_col_matching==="equipmentName - sensorName"){
                      formData.set('autocreate_sensors', this.autocreate_sensors)
                      formData.set('autocreate_sensor_floor', this.autocreate_sensor_floor)
                      formData.set('autocreate_sensor_type', this.autocreate_sensor_type)
                  }
              }
          }
          if(this.diffOptions){
              formData.set('diff_mode', this.diffMode)
          }
          if(this.hasRemoveSwitch){
              formData.set('remove_existing', this.removeExisting)
          } else if (this.cmcmode){
              formData.set('facility_name', this.$store.state.pointsListStore.pointsList.facility_name)
              formData.set('result_name', 'hkl_cmc')
              formData.set('result_description', '')
          } else if (this.sensorId){
              formData.set('sensor_id', this.sensorId)
          }
        this.percentCompleted = 0
        try {
          let response =await upload(formData, this.onProgress, url)
            if(response.error){
                this.uploadError = response.error
                this.currentStatus = response.error
                this.uploading = false
            } else {
                this.currentStatus = 'Upload Completed.'
                this.uploading = false
            }
        } catch (err) {
          this.uploadError = err.response
            if(this.uploadError&&this.uploadError.data&&this.uploadError.data.msg){
                this.currentStatus = this.uploadError.data.msg
            } else {
                this.currentStatus = 'Fail.  Please Retry.'
            }
          this.uploading = false
        }

        return 'done'
      }
    }
  }
</script>

<style scoped>

</style>
